import {lazy} from 'react'

const GiftShopSimilarChooseAccountScreen = lazy(
  () => import('./GiftShopSimilarChooseAccountScreen') 
)

export {GiftShopSimilarChooseAccountScreen}
